export default {
  items: [
    {
      name: 'Nurse',
      url: '/nurse',
      icon: 'icon-speedometer',
    },
    // {
    //   name: 'Transporter',
    //   url: '/transporter',
    //   icon: 'icon-map',
    // }
  ]
};



// WEBPACK FOOTER //
// ./src/_nav.js